import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { map, range } from 'lodash';

import Star from 'components/svg/Star';

import './StarRating.scss';

export default function StarRating({ className, rating, outOf }) {
	return (
		<div className={classnames('star-rating', className)}>
			{map(range(0, outOf), (starValue) => (
				<Star
					key={starValue}
					value={rating - starValue}
				/>
			))}
		</div>
	);
}

StarRating.propTypes = {
	className: PropTypes.string,
	/** The rating to show */
	rating: PropTypes.number,
	/** What the rating is out of */
	outOf: PropTypes.number
};

StarRating.defaultProps = {
	rating: 0,
	outOf: 5
};
